import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getRequest } from 'apis/ApiInstence';
import { toast } from 'react-toastify';
import { FaUser, FaEnvelope, FaPhoneAlt, FaBriefcase, FaGraduationCap, FaStar, FaBuilding, FaInfoCircle } from 'react-icons/fa';

const ViewMentor = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [mentor, setMentor] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchMentor = async () => {
            try {
                const res = await getRequest(`mentors/${id}`);
                setMentor(res?.data);
            } catch (err) {
                console.error(err);
                toast.error("Failed to load mentor details");
            } finally {
                setLoading(false);
            }
        };
        fetchMentor();
    }, [id]);

    if (loading) return <div className="text-center mt-5">Loading...</div>;
    if (!mentor) return <div className="text-center mt-5">Mentor not found</div>;

    const user = mentor.user || {};

    return (
        <div className="container-fluid mt-5 mb-5">
            <div className="mainheadig mx-4 mb-4 d-flex justify-content-between align-items-center">
                <h4 className="text-white font-weight-bold">View Mentor Profile</h4>
                <button className="btn btn-light font-weight-bold" onClick={() => navigate(-1)}>Back</button>
            </div>
            
            <div className="card mx-4 border-0 shadow-lg" style={{ borderRadius: '15px', overflow: 'hidden' }}>
                {/* Banner Section */}
                <div style={{
                    height: '150px',
                    background: 'linear-gradient(135deg, #2e7d32 0%, #4caf50 100%)',
                    position: 'relative'
                }}></div>

                <div className="card-body px-5 pb-5" style={{ position: 'relative', marginTop: '-75px' }}>
                    <div className="d-flex flex-column flex-md-row align-items-center align-items-md-end mb-4">
                        {/* Profile Image */}
                        <div style={{ 
                            width: '150px', 
                            height: '150px', 
                            borderRadius: '50%', 
                            border: '5px solid white',
                            boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
                            backgroundColor: '#fff',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            overflow: 'hidden',
                            flexShrink: 0,
                            zIndex: 1
                        }}>
                            {mentor.image ? (
                                <img src={`${process.env.REACT_APP_BACKEND}uploads/${mentor.image}`} alt="mentor" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                            ) : (
                                <FaUser size={50} color="#ccc" />
                            )}
                        </div>
                        
                        {/* Title and Badges */}
                        <div className="ml-md-4 mt-3 mt-md-0 text-center text-md-left" style={{ flexGrow: 1 }}>
                            <h3 className="font-weight-bold mb-1" style={{ color: '#333' }}>{`${user.firstName || ''} ${user.lastName || ''}`}</h3>
                            <div className="text-muted mb-2" style={{ fontSize: '1.1rem' }}>{mentor.designation || 'Mentor'}</div>
                            <div className="d-flex flex-wrap justify-content-center justify-content-md-start mb-2">
                                {mentor.expertise && <span className="badge badge-success mr-2 py-2 px-3 mt-2" style={{ fontSize: '13px', borderRadius: '20px' }}>{mentor.expertise}</span>}
                            </div>
                        </div>
                    </div>

                    <div className="row mt-5">
                        {/* Left Column: Contact & Basic Info */}
                        <div className="col-lg-4 mb-4">
                            <div className="p-4" style={{ backgroundColor: '#f8f9fa', borderRadius: '12px', height: '100%' }}>
                                <h5 className="font-weight-bold mb-4 border-bottom pb-2" style={{ color: '#2e7d32' }}>Contact Details</h5>
                                
                                <div className="d-flex align-items-center mb-3">
                                    <div style={{ width: '35px', color: '#4caf50' }}><FaEnvelope size={18} /></div>
                                    <div>
                                        <div className="text-muted small">Email</div>
                                        <div className="font-weight-bold">{user.email}</div>
                                    </div>
                                </div>
                                
                                <div className="d-flex align-items-center mb-3">
                                    <div style={{ width: '35px', color: '#4caf50' }}><FaPhoneAlt size={18} /></div>
                                    <div>
                                        <div className="text-muted small">Mobile</div>
                                        <div className="font-weight-bold">{user.mobile}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Right Column: Professional Details */}
                        <div className="col-lg-8">
                            <div className="p-4" style={{ backgroundColor: '#ffffff', border: '1px solid #eee', borderRadius: '12px', height: '100%' }}>
                                <h5 className="font-weight-bold mb-4 border-bottom pb-2" style={{ color: '#2e7d32' }}>Professional Details</h5>
                                
                                <div className="row mb-4">
                                    <div className="col-md-6 mb-3 mb-md-0">
                                        <div className="d-flex align-items-center mb-1">
                                            <FaBuilding className="mr-2 text-success" />
                                            <span className="text-muted small">Company/Organization</span>
                                        </div>
                                        <div className="font-weight-bold ml-4 pl-1">{mentor.company || 'N/A'}</div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="d-flex align-items-center mb-1">
                                            <FaBriefcase className="mr-2 text-success" />
                                            <span className="text-muted small">Designation</span>
                                        </div>
                                        <div className="font-weight-bold ml-4 pl-1">{mentor.designation || 'N/A'}</div>
                                    </div>
                                </div>
                                
                                <div className="row mb-4 border-top pt-3">
                                    <div className="col-md-6 mb-3 mb-md-0">
                                        <div className="d-flex align-items-center mb-1">
                                            <FaGraduationCap className="mr-2 text-success" />
                                            <span className="text-muted small">Qualification</span>
                                        </div>
                                        <div className="font-weight-bold ml-4 pl-1">{mentor.qualification || 'N/A'}</div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="d-flex align-items-center mb-1">
                                            <FaStar className="mr-2 text-success" />
                                            <span className="text-muted small">Expertise Area</span>
                                        </div>
                                        <div className="font-weight-bold ml-4 pl-1">{mentor.expertise || 'N/A'}</div>
                                    </div>
                                </div>
                                
                                <div className="mt-4 border-top pt-4">
                                    <h5 className="font-weight-bold mb-3 d-flex align-items-center" style={{ color: '#2e7d32' }}>
                                        <FaInfoCircle className="mr-2" /> Bio / About
                                    </h5>
                                    <div className="p-3" style={{ backgroundColor: '#f1f8e9', borderLeft: '4px solid #8bc34a', borderRadius: '4px' }}>
                                        <p className="text-secondary mb-0" style={{ lineHeight: '1.7', whiteSpace: 'pre-line' }}>
                                            {mentor.bio || 'No bio provided.'}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ViewMentor;
